(function()
{
	//Import classes
	var BaseState = include('WGBH.BaseState'),
		IndexPanel = include('WGBH.IndexPanel');


	/**
	 * The logic for the index state
	 * @class WGBH.IndexState
	 * @extends springroll.easeljs.BaseState
	 */
	var IndexState = function(options)
	{
		BaseState.call(this, new IndexPanel(), options);
	};
	
	
	// Extend the base class
	var p = extend(IndexState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		
		this.goplay=this.goplay.bind(this);
	};
	
	p.clickbg=function(ev) {
		app.trackstrayclick(ev.x,ev.y);
	};

	p.setup=function() {
		this.background=this.panel.background;
		this.playbutton=this.panel.items.playbutton;
		this.panel.playbutton.on(app.taptype,this.goplay);
		this.panel.buttons.on("background",this.clickbg);
	};

	p.ready=function() {
		this.setup();
	};
	
	p.goplay=function() {
		this.nextState();
	};

	
	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
	
	};

	//Assign to namespace
	namespace("WGBH").IndexState = IndexState;
}());
